"use strict";
// --------------------------------------------------------------------------------------------------------------------
// <copyright file="Root.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   TypeScript implementation of the HxRoot object
//   THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND
// </summary>
// --------------------------------------------------------------------------------------------------------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxRoot = void 0;
var HxObject_1 = __importDefault(require("./HxObject"));
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxGeoCoordinates_1 = require("./HxGeoCoordinates");
var HxRoot = /** @class */ (function (_super) {
    __extends(HxRoot, _super);
    function HxRoot(objectId, storageSequenceNumber, obj, activeSet) {
        var _this = _super.call(this, objectId, HxObjectType_1.default.HxRoot, storageSequenceNumber, activeSet) || this;
        _this.update(obj);
        return _this;
    }
    HxRoot.getTailoredExperienceTimeRange = function (item) {
        return item.startAndEndRange;
    };
    HxRoot.prototype.update = function (obj) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                switch (key) {
                    case '1':
                        this.objectId = new HxObjectID_1.default(v);
                        break;
                    case '2':
                        this.parentId = new HxObjectID_1.default(v);
                        break;
                    case '1220':
                        this.accountsForSettingsUIId = new HxObjectID_1.default(v);
                        break;
                    case 'A92':
                        this.accountsSynced = v;
                        break;
                    case '10CD':
                        this.accountsSyncingCalendarId = new HxObjectID_1.default(v);
                        break;
                    case '10CF':
                        this.accountsSyncingMailId = new HxObjectID_1.default(v);
                        break;
                    case '10D0':
                        this.accountsSyncingMailOrCalendarId = new HxObjectID_1.default(v);
                        break;
                    case '155C':
                        this.activityFeedId = new HxObjectID_1.default(v);
                        break;
                    case '157D':
                        this.activityFeedUnseenCount = v;
                        break;
                    case '11E0':
                        this.allAccountsUnifiedMailboxId = new HxObjectID_1.default(v);
                        break;
                    case 'BA8':
                        var badgeCountPushNotificationInfo_AllAccountIdsValues = v;
                        this.badgeCountPushNotificationInfo_AllAccountIds = new Array(badgeCountPushNotificationInfo_AllAccountIdsValues.length);
                        for (var i = 0; i < badgeCountPushNotificationInfo_AllAccountIdsValues.length; i++) {
                            this.badgeCountPushNotificationInfo_AllAccountIds[i] = badgeCountPushNotificationInfo_AllAccountIdsValues[i];
                        }
                        break;
                    case 'BA9':
                        this.badgeCountPushNotificationInfo_DeviceId = v;
                        break;
                    case 'BAA':
                        this.badgeCountPushNotificationInfo_Endpoint = v;
                        break;
                    case 'BAB':
                        var badgeCountPushNotificationInfo_NonHxAccountIdsValues = v;
                        this.badgeCountPushNotificationInfo_NonHxAccountIds = new Array(badgeCountPushNotificationInfo_NonHxAccountIdsValues.length);
                        for (var i = 0; i < badgeCountPushNotificationInfo_NonHxAccountIdsValues.length; i++) {
                            this.badgeCountPushNotificationInfo_NonHxAccountIds[i] = badgeCountPushNotificationInfo_NonHxAccountIdsValues[i];
                        }
                        break;
                    case '8':
                        this.calendarId = new HxObjectID_1.default(v);
                        break;
                    case '13D0':
                        this.contactsSortDirection = v;
                        break;
                    case '13D1':
                        this.contactsSortProperty = v;
                        break;
                    case 'BB3':
                        this.emailAddressOfLastGoldenAccountAdded = v;
                        break;
                    case '7':
                        this.errorsId = new HxObjectID_1.default(v);
                        break;
                    case '1103':
                        this.flightsETag = v;
                        break;
                    case '1104':
                        this.flightsLastUpdateTime = new Date(v);
                        break;
                    case '6A7':
                        this.globalEasPoliciesId = new HxObjectID_1.default(v);
                        break;
                    case '1125':
                        this.hxCoreIsActive = v;
                        break;
                    case '133B':
                        this.isContactDisplayNameInFirstLastOrder = v;
                        break;
                    case '6FE':
                        this.isDeviceLocationAccessAllowed = v;
                        break;
                    case '1291':
                        this.isDiskFull = v;
                        break;
                    case '14CE':
                        this.isMobileAppEducationEnabled = v;
                        break;
                    case 'ED8':
                        this.isSingleAccountEnabled = v;
                        break;
                    case '6E7':
                        this.lastDeviceLocationUpdateTime = new Date(v);
                        break;
                    case '6E8':
                        this.lastKnownDeviceLocation = HxGeoCoordinates_1.deserializeHxGeoCoordinates(v);
                        break;
                    case 'B4C':
                        this.lastStorageMaintenanceTime = new Date(v);
                        break;
                    case '79D':
                        this.localUdaCalendarSyncComplete = v;
                        break;
                    case '79E':
                        this.localUdaContactSyncComplete = v;
                        break;
                    case '913':
                        this.mailToastGroupCacheId = new HxObjectID_1.default(v);
                        break;
                    case '155D':
                        this.messageReactionFeedId = new HxObjectID_1.default(v);
                        break;
                    case 'AC9':
                        this.nextAccountInstanceId = v;
                        break;
                    case '41E':
                        this.notificationCacheId = new HxObjectID_1.default(v);
                        break;
                    case '933':
                        this.notificationChannelExpiration = new Date(v);
                        break;
                    case '934':
                        this.notificationChannelUri = v;
                        break;
                    case 'F46':
                        this.searchSessionsId = new HxObjectID_1.default(v);
                        break;
                    case '79F':
                        this.sentLocalUdaTelemetry = v;
                        break;
                    case '3DA':
                        this.settingsId = new HxObjectID_1.default(v);
                        break;
                    case 'B4D':
                        this.storageMaintenanceStatus = v;
                        break;
                    case '4':
                        this.storeCreationTime = new Date(v);
                        break;
                    case '69F':
                        this.storeGeneration = v;
                        break;
                    case 'EFC':
                        this.storeMigrationState = v;
                        break;
                    case 'E17':
                        this.tailoredExperiencesId = new HxObjectID_1.default(v);
                        break;
                    case 'D23':
                        this.teachingCalloutDataCatalogId = new HxObjectID_1.default(v);
                        break;
                    case '153B':
                        this.unifiedRecentlyUsedViewsId = new HxObjectID_1.default(v);
                        break;
                    case 'B84':
                        this.useSandboxNotificationEndpoint = v;
                        break;
                    case '13B4':
                        this.widgetDataId = new HxObjectID_1.default(v);
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HxRoot.prototype.getAccountsForSettingsUI = function (sessionId) {
        return this.activeSet.getCollection(this.accountsForSettingsUIId, sessionId);
    };
    HxRoot.prototype.getAccountsSyncingCalendar = function (sessionId) {
        return this.activeSet.getCollection(this.accountsSyncingCalendarId, sessionId);
    };
    HxRoot.prototype.getAccountsSyncingMail = function (sessionId) {
        return this.activeSet.getCollection(this.accountsSyncingMailId, sessionId);
    };
    HxRoot.prototype.getAccountsSyncingMailOrCalendar = function (sessionId) {
        return this.activeSet.getCollection(this.accountsSyncingMailOrCalendarId, sessionId);
    };
    HxRoot.prototype.getActivityFeed = function (sessionId) {
        return this.activeSet.getCollection(this.activityFeedId, sessionId);
    };
    HxRoot.prototype.getAllAccountsUnifiedMailbox = function (sessionId) {
        return this.activeSet.getObject(this.allAccountsUnifiedMailboxId, sessionId).then(function (result) { return result; });
    };
    HxRoot.prototype.getCalendar = function (sessionId) {
        return this.activeSet.getObject(this.calendarId, sessionId).then(function (result) { return result; });
    };
    HxRoot.prototype.getErrors = function (sessionId) {
        return this.activeSet.getCollection(this.errorsId, sessionId);
    };
    HxRoot.prototype.getGlobalEasPolicies = function (sessionId) {
        return this.activeSet.getObject(this.globalEasPoliciesId, sessionId).then(function (result) { return result; });
    };
    HxRoot.prototype.getMailToastGroupCache = function (sessionId) {
        return this.activeSet.getCollection(this.mailToastGroupCacheId, sessionId);
    };
    HxRoot.prototype.getMessageReactionFeed = function (sessionId) {
        return this.activeSet.getCollection(this.messageReactionFeedId, sessionId);
    };
    HxRoot.prototype.getNotificationCache = function (sessionId) {
        return this.activeSet.getCollection(this.notificationCacheId, sessionId);
    };
    HxRoot.prototype.getSearchSessions = function (sessionId) {
        return this.activeSet.getCollection(this.searchSessionsId, sessionId);
    };
    HxRoot.prototype.getSettings = function (sessionId) {
        return this.activeSet.getObject(this.settingsId, sessionId).then(function (result) { return result; });
    };
    HxRoot.prototype.getTailoredExperiences = function (start, end, sessionId) {
        return this.activeSet.getCollectionByTimeRange(this.tailoredExperiencesId, HxObjectType_1.default.HxTailoredExperienceCollection, 3611 /* HxTailoredExperience_StartAndEndRange */, start, end, HxRoot.getTailoredExperienceTimeRange, sessionId);
    };
    HxRoot.prototype.getTeachingCalloutDataCatalog = function (sessionId) {
        return this.activeSet.getObject(this.teachingCalloutDataCatalogId, sessionId).then(function (result) { return result; });
    };
    HxRoot.prototype.getUnifiedRecentlyUsedViews = function (sessionId) {
        return this.activeSet.getCollection(this.unifiedRecentlyUsedViewsId, sessionId);
    };
    HxRoot.prototype.getWidgetData = function (sessionId) {
        return this.activeSet.getObject(this.widgetDataId, sessionId).then(function (result) { return result; });
    };
    return HxRoot;
}(HxObject_1.default));
exports.HxRoot = HxRoot;
exports.default = HxRoot;
